import { render } from "./InLoad.vue?vue&type=template&id=95dc4e2e&scoped=true"
import script from "./InLoad.vue?vue&type=script&lang=js"
export * from "./InLoad.vue?vue&type=script&lang=js"

import "./InLoad.vue?vue&type=style&index=0&id=95dc4e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95dc4e2e"]])

export default __exports__